export const monitoringTour = {
    module: 'monitoring',
    title: 'Monitoring Tour',
    title_vi: 'Hướng dẫn Giám sát',
    description: 'Explore KPI Dashboard, Authority Readiness, Programs, Periods, Framework Monitoring and the related workspaces. Read the screens and controls without submitting business changes.',
    description_vi: 'Tìm hiểu KPI, Sẵn sàng cơ quan, Chương trình, Kỳ kiểm tra, Giám sát theo khung và các không gian làm việc liên quan. Xem màn hình và điều khiển mà không gửi thay đổi nghiệp vụ.',
    estimated_duration_seconds: 333,
    revision: '2026-10-26.3',
    steps: [
        {
            step_id: 'explore_monitoring_kpi',
            navigate_to: '/admin/monitoring/kpi',
            target: '[data-testid="monitoring-kpi-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-kpi-page"][data-tour-ready="true"]',
            title: 'KPI Dashboard',
            title_vi: 'KPI',
            description: 'Select the programme whose indicators you need to inspect. Current values come from recorded snapshots and the trend table uses that programme’s history. Without a selected programme the page asks you to choose one; absence of a snapshot is not a zero score.',
            description_vi: 'Chọn chương trình có chỉ số cần xem. Giá trị hiện tại lấy từ ảnh chụp đã ghi, còn bảng xu hướng dùng lịch sử của chương trình đó. Nếu chưa chọn chương trình, trang yêu cầu bạn chọn; chưa có ảnh chụp không đồng nghĩa điểm bằng không.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'feature_kpi_programme',
            navigate_to: '/admin/monitoring/kpi',
            target: '[data-testid="monitoring-kpi-page"] .dm-filters > div',
            wait_for: '[data-testid="monitoring-kpi-page"][data-tour-ready="true"]',
            title: 'Choose the Programme Before Reading Metrics',
            title_vi: 'Chọn chương trình trước khi đọc chỉ số',
            description: 'The programme selector defines the scope of the KPI dashboard. After a selection, inspect the snapshot timestamp and compare actual values with targets; the chart/table switch appears only when a snapshot exists. Do not compare two programmes as though their snapshot dates and targets were identical.',
            description_vi: 'Bộ chọn chương trình xác định phạm vi bảng chỉ số. Sau khi chọn, xem thời điểm ảnh chụp và so sánh giá trị thực tế với mục tiêu; nút chuyển biểu đồ/bảng chỉ xuất hiện khi có ảnh chụp. Không so sánh hai chương trình như thể chúng có cùng thời điểm chụp và mục tiêu.',
            position: 'bottom',
            duration_ms: 19000,
        },
        {
            step_id: 'feature_kpi_snapshot',
            navigate_to: '/admin/monitoring/kpi',
            target: '[data-testid="monitoring-kpi-page"] .dm-header__actions > button.btn-primary',
            wait_for: '[data-testid="monitoring-kpi-page"][data-tour-ready="true"]',
            title: 'Capture Is a Separate Write',
            title_vi: 'Chụp chỉ số là thao tác ghi riêng',
            description: 'Capture Snapshot records a new measurement for the selected programme and is disabled until a programme is selected or while saving. Existing history remains a record of earlier measurements; it is not recalculated merely by viewing the page. This walkthrough highlights the control without capturing or exporting data.',
            description_vi: 'Chụp chỉ số ghi phép đo mới cho chương trình đã chọn và bị vô hiệu khi chưa chọn chương trình hoặc đang lưu. Lịch sử hiện có ghi lại phép đo trước đó, không được tính lại chỉ vì mở trang. Hướng dẫn chỉ tô sáng điều khiển, không chụp hoặc xuất dữ liệu.',
            position: 'bottom',
            duration_ms: 20000,
        },
        {
            step_id: 'explore_monitoring_authority_readiness',
            navigate_to: '/admin/monitoring/authority-readiness',
            target: '[data-tour-feature="tour-monitoring-authority-readiness"]',
            wait_for: '[data-testid="monitoring-authority-readiness-page"][data-tour-ready="true"]',
            title: 'Authority Readiness',
            title_vi: 'Sẵn sàng cơ quan',
            description: 'Compare framework, readiness status, available package and last drill date. A package and a drill record provide different evidence; neither is authority acceptance. Inspect the relevant request or readiness material before planning a response.',
            description_vi: 'So sánh khung, trạng thái sẵn sàng, gói có sẵn và ngày diễn tập cuối. Gói và bản ghi diễn tập là tài liệu khác nhau; không phải cơ quan chấp nhận. Xem yêu cầu hoặc tài liệu sẵn sàng phù hợp trước khi chuẩn bị phản hồi.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_programs',
            navigate_to: '/admin/monitoring/programs',
            target: '[data-testid="monitoring-programs-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-programs-page"][data-tour-ready="true"]',
            title: 'Programs',
            title_vi: 'Chương trình',
            description: 'Compare programme scope, frequency, status, owner and staleness.',
            description_vi: 'So sánh phạm vi, tần suất, trạng thái, người sở hữu và độ cũ của chương trình.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_programs_register',
            navigate_to: '/admin/monitoring/programs',
            target: '[data-tour-register="explore_monitoring_programs_register"]',
            wait_for: '[data-testid="monitoring-programs-page"][data-tour-ready="true"]',
            title: 'Programs — record decisions',
            title_vi: 'Chương trình — quyết định theo bản ghi',
            description: 'Linked forms and stale-record details have separate reads and appear when available. An active programme schedules oversight; it does not prove its tasks or reviews were completed.',
            description_vi: 'Biểu mẫu liên kết và chi tiết mục cũ tải riêng, hiển thị khi có. Chương trình hoạt động lên lịch giám sát, không chứng minh nhiệm vụ hoặc rà soát đã hoàn tất.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_periods',
            navigate_to: '/admin/monitoring/periods',
            target: '[data-testid="monitoring-periods-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-periods-page"]:is([data-tour-ready="true"],[data-tour-scope-ready="true"])',
            title: 'Periods',
            title_vi: 'Kỳ kiểm tra',
            description: 'This page starts with programme scope; it has not read period results until a programme is chosen. After this tour, select a programme to compare period dates, status, reviewers, task counts and staleness.',
            description_vi: 'Trang bắt đầu ở phạm vi chương trình; kết quả các kỳ chưa được đọc cho tới khi chọn chương trình. Sau hướng dẫn, chọn chương trình để so sánh ngày kỳ, trạng thái, người rà soát, số nhiệm vụ và độ cũ.',
            position: 'bottom',
            duration_ms: 24000,
        },
        {
            step_id: 'explore_monitoring_periods_register',
            navigate_to: '/admin/monitoring/periods',
            target: '[data-tour-register="explore_monitoring_periods_register"]',
            wait_for: '[data-testid="monitoring-periods-page"]:is([data-tour-ready="true"],[data-tour-scope-ready="true"])',
            title: 'Periods — record decisions',
            title_vi: 'Kỳ kiểm tra — quyết định theo bản ghi',
            description: 'The initial table is a column guide while no programme is selected. With records loaded, distinguish scheduled periods from completed reviews. Detail summaries require a deliberately selected period and cannot be inferred from this initial register.',
            description_vi: 'Khi chưa chọn chương trình, bảng ban đầu chỉ hướng dẫn ý nghĩa các cột. Sau khi tải bản ghi, phân biệt kỳ đã lên lịch với rà soát đã hoàn tất. Tóm tắt chi tiết cần kỳ được chủ động chọn, không được suy ra từ sổ ban đầu.',
            position: 'bottom',
            duration_ms: 24000,
        },
        {
            step_id: 'explore_monitoring_framework_link',
            navigate_to: '/admin/monitoring/framework-link',
            target: '[data-tour-feature="tour-monitoring-framework-link"]',
            wait_for: '[data-testid="monitoring-framework-link-page"][data-tour-ready="true"]',
            title: 'Framework Monitoring',
            title_vi: 'Giám sát theo khung',
            description: 'Compare programme, linked framework, recorded readiness score and creation date. A link defines scope; it is not an assessment or completed obligation. Framework-link write access is separate from reading this register.',
            description_vi: 'So sánh chương trình, khung liên kết, điểm sẵn sàng đã ghi và ngày tạo. Liên kết xác định phạm vi, không phải đánh giá hoặc nghĩa vụ đã xong. Quyền ghi liên kết khung tách khỏi đọc sổ.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_tasks',
            navigate_to: '/admin/monitoring/tasks',
            target: '[data-testid="monitoring-tasks-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-tasks-page"]:is([data-tour-ready="true"],[data-tour-scope-ready="true"])',
            title: 'Tasks',
            title_vi: 'Nhiệm vụ',
            description: 'The selectors set programme and review-period scope; no task read occurs until both are selected. After the tour, choose them to inspect assignee, deadline, status, checklist and notes. This guide leaves the scope unchanged.',
            description_vi: 'Các bộ chọn xác định phạm vi chương trình và kỳ rà soát; tác vụ chưa được đọc cho tới khi chọn cả hai. Sau hướng dẫn, chọn chúng để xem người được giao, hạn, trạng thái, danh sách kiểm tra và ghi chú. Hướng dẫn giữ nguyên phạm vi.',
            position: 'bottom',
            duration_ms: 24000,
        },
        {
            step_id: 'explore_monitoring_tasks_register',
            navigate_to: '/admin/monitoring/tasks',
            target: '[data-tour-register="explore_monitoring_tasks_register"]',
            wait_for: '[data-testid="monitoring-tasks-page"]:is([data-tour-ready="true"],[data-tour-scope-ready="true"])',
            title: 'Tasks — record decisions',
            title_vi: 'Nhiệm vụ — quyết định theo bản ghi',
            description: 'While no programme and period are selected, the table is a column guide rather than loaded tasks. Once records are loaded, read task state with supporting evidence. Filtering or viewing the register neither completes work nor changes responsibility.',
            description_vi: 'Khi chưa chọn chương trình và kỳ, bảng chỉ hướng dẫn ý nghĩa các cột, chưa phải tác vụ đã tải. Sau khi tải bản ghi, đọc trạng thái nhiệm vụ cùng chứng cứ hỗ trợ. Lọc hoặc xem sổ không hoàn thành việc hoặc đổi trách nhiệm.',
            position: 'bottom',
            duration_ms: 24000,
        },
        {
            step_id: 'explore_monitoring_task_templates',
            navigate_to: '/admin/monitoring/task-templates',
            target: '[data-testid="monitoring-task-templates-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-task-templates-page"][data-tour-ready="true"]',
            title: 'Task Templates',
            title_vi: 'Mẫu nhiệm vụ',
            description: 'Compare template category, priority, checklist count, effort, preseeded designation and version.',
            description_vi: 'So sánh loại mẫu, ưu tiên, số mục kiểm tra, công sức, dấu mẫu có sẵn và phiên bản.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_task_templates_register',
            navigate_to: '/admin/monitoring/task-templates',
            target: '[data-tour-register="explore_monitoring_task_templates_register"]',
            wait_for: '[data-testid="monitoring-task-templates-page"][data-tour-ready="true"]',
            title: 'Task Templates — record decisions',
            title_vi: 'Mẫu nhiệm vụ — quyết định theo bản ghi',
            description: 'A reusable template defines work; an instantiated task records its execution. Check the version and intended context before reusing a checklist.',
            description_vi: 'Mẫu dùng lại định nghĩa việc; nhiệm vụ được tạo ghi việc thực hiện. Kiểm tra phiên bản và bối cảnh trước khi dùng lại danh sách.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_raci',
            navigate_to: '/admin/monitoring/raci',
            target: '[data-testid="monitoring-raci-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-raci-page"][data-tour-ready="true"]',
            title: 'RACI Matrix',
            title_vi: 'Ma trận RACI',
            description: 'Compare activity, framework, responsible, accountable, consulted and informed assignments with review frequency. These are governance responsibilities, not technical access grants. Missing assignments call for ownership follow-up; exporting the matrix has its own permission boundary.',
            description_vi: 'So sánh hoạt động, khung, bên thực hiện, chịu trách nhiệm, được tham vấn và được thông báo cùng tần suất rà soát. Đây là trách nhiệm quản trị, không phải quyền kỹ thuật. Thiếu phân công cần theo dõi người sở hữu; xuất ma trận có phạm vi quyền riêng.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_ric',
            navigate_to: '/admin/monitoring/ric',
            target: '[data-testid="monitoring-ric-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-ric-page"][data-tour-ready="true"]',
            title: 'Regulator Inquiries',
            title_vi: 'Yêu cầu cơ quan',
            description: 'Compare inquiry reference, regulator, type, status, deadline, lead and linked programme.',
            description_vi: 'So sánh tham chiếu yêu cầu, cơ quan, loại, trạng thái, hạn, người phụ trách và chương trình liên kết.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_ric_register',
            navigate_to: '/admin/monitoring/ric',
            target: '[data-tour-register="explore_monitoring_ric_register"]',
            wait_for: '[data-testid="monitoring-ric-page"][data-tour-ready="true"]',
            title: 'Regulator Inquiries — record decisions',
            title_vi: 'Yêu cầu cơ quan — quyết định theo bản ghi',
            description: 'Follow-up counts and detailed questions/responses are distinct views. A prepared response is not a recorded submission or external acceptance.',
            description_vi: 'Số lần theo dõi và chi tiết câu hỏi/trả lời là góc nhìn riêng. Phản hồi chuẩn bị chưa phải đã nộp hoặc được bên ngoài chấp nhận.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_monitoring_change_review',
            navigate_to: '/admin/monitoring/change-review',
            target: '[data-testid="monitoring-change-review-page"] .dm-filters',
            wait_for: '[data-testid="monitoring-change-review-page"][data-tour-ready="true"]',
            title: 'Change Review',
            title_vi: 'Xem xét thay đổi',
            description: 'Read the change reference, framework, impact assessment and recorded decision together. A proposed change differs from an approved decision and from implementation evidence. Viewing this queue neither approves a change nor updates its source controls.',
            description_vi: 'Đọc cùng tham chiếu thay đổi, khung, đánh giá tác động và quyết định đã ghi. Đề xuất thay đổi khác với quyết định phê duyệt và tài liệu thực hiện. Xem hàng đợi không phê duyệt hoặc cập nhật kiểm soát nguồn.',
            position: 'bottom',
            duration_ms: 18000,
        },
    ],
};
//# sourceMappingURL=monitoring.js.map